import React, { ReactNode } from 'react';
import { Spin, Result, Button } from 'antd';
import { LoadingOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import LoginButton from './LoginButton';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRoles = [] 
}) => {
  const { isAuthenticated, isLoading, user } = useAuth0();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          tip="Loading..."
        >
          <div style={{ padding: '50px' }}></div>
        </Spin>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Result
        icon={<LockOutlined />}
        title="Authentication Required"
        subTitle="Please log in to access this page."
        extra={<LoginButton />}
      />
    );
  }

  // Check role permissions if required
  if (requiredRoles.length > 0 && user) {
    const userRoles = user['https://api.fitmanager.com/roles'] || [];
    const hasRequiredRole = requiredRoles.some(role => 
      userRoles.includes(role.toLowerCase())
    );

    if (!hasRequiredRole) {
      return (
        <Result
          status="403"
          title="Access Denied"
          subTitle={`You need one of these roles: ${requiredRoles.join(', ')}`}
          extra={
            <Button type="primary" onClick={() => window.history.back()}>
              Go Back
            </Button>
          }
        />
      );
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute; 